import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { MediaQuery } from '@grandvisionhq/common';
import LocationSearchTabsContainer from '../LocationSearchTabs/LocationSearchTabsContainer.js';

const LocationSearch = (_param)=>{
    var { className , searchForm , listContent , listTopContent , mapContent , showTabs =false , scrollToHandlerId  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "searchForm",
        "listContent",
        "listTopContent",
        "mapContent",
        "showTabs",
        "scrollToHandlerId"
    ]);
    const isMobile = MediaQuery.useIsPhone();
    return /*#__PURE__*/ React.createElement("article", swcHelpers.extends({}, rest, {
        className: classnames('location-search', className)
    }), listTopContent, isMobile && /*#__PURE__*/ React.createElement("div", {
        id: scrollToHandlerId,
        className: "location-search__search-form"
    }, searchForm), /*#__PURE__*/ React.createElement("div", {
        className: "location-search__wrapper"
    }, /*#__PURE__*/ React.createElement(LocationSearchTabsContainer, {
        showTabs: showTabs,
        listContent: listContent,
        mapContent: mapContent
    })));
};

export { LocationSearch as default };
//# sourceMappingURL=LocationSearch.js.map
